import type { BaseItemSchema } from "@memorang/types";
import type { CheckboxType } from "../components/dialogs/ReviewAnswersDialog";

const getFilteredChildrenItems = (
	baseItems: BaseItemSchema[],
	filters: CheckboxType[],
	isSummativeTest?: boolean,
) => {
	const f = new Set<CheckboxType>(filters);
	const ALL: CheckboxType[] = [
		"correct",
		"incorrect",
		"skipped",
		"almostcorrect",
		"marked",
	];
	const hasAll = ALL.every((x) => f.has(x));

	// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
	return baseItems.filter(({ answer }) => {
		const hasAnswer = !!answer;
		if (hasAll) {
			return hasAnswer;
		}
		if (!hasAnswer) {
			return false;
		}

		const selectedCount = Array.isArray(answer!.selectedChoiceIds)
			? answer!.selectedChoiceIds!.length
			: 0;

		const hasSelection = selectedCount > 0;
		const hasScore = typeof answer!.score === "number";
		const hasExplicitCorrectness = typeof answer!.correct === "boolean";
		const hasTime =
			typeof answer!.timeTaken === "number" &&
			(answer!.timeTaken as number) > 0;
		const confidence =
			typeof answer!.confidence === "number" ? answer!.confidence! : null;

		const countedForCorrect = isSummativeTest
			? true
			: hasSelection && confidence === 100;
		const isCorrect = !!answer!.correct && countedForCorrect;

		const countedForIncorrect = isSummativeTest
			? true
			: (hasSelection ||
					hasScore ||
					(hasExplicitCorrectness && answer!.correct === false)) &&
				hasTime;
		const isIncorrect = answer!.correct === false && countedForIncorrect;

		const isSkipped = !hasSelection;

		const isMarked = !!answer!.marked;

		const isAlmostCorrect = answer!.correct === true && confidence === 50;

		return (
			(f.has("correct") && isCorrect) ||
			(f.has("incorrect") && isIncorrect) ||
			(f.has("skipped") && isSkipped) ||
			(f.has("marked") && isMarked) ||
			(f.has("almostcorrect") && isAlmostCorrect)
		);
	});
};

export const getFilteredSessionItems = (
	sessionItems: BaseItemSchema[],
	filters: CheckboxType[],
	isSummativeTest?: boolean,
) => {
	const filteredItems = getFilteredChildrenItems(
		sessionItems,
		filters,
		isSummativeTest,
	);
	return filteredItems;
};
